import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { deleteCartLines as deleteLines, RemoveCartLinesApiParameter } from "@tps/App/Services/CartService";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLinesIds: string[];
    } & HasOnSuccess<any>,
    RemoveCartLinesApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cartLinesIds: props.parameter.cartLinesIds,
        cartId: API_URL_CURRENT_FRAGMENT,
    };
};

export const RemoveCartLines: HandlerType = async props => {
    await deleteLines(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RemoveCartLines, ExecuteOnSuccessCallback];

const deleteCartLines = createHandlerChainRunner(chain, "DeleteCartLines");
export default deleteCartLines;
